// extracted by mini-css-extract-plugin
export default {"borderedBox":"HubBorderedBox_borderedBox__29v+z","borderBoxContent":"HubBorderedBox_borderBoxContent__9epRA","actions":"HubBorderedBox_actions__G2MUB"};